import { useState, useEffect } from 'react';
import { breakpoints } from 'style/config';
import { DebouncedResize } from 'constants/events';

const usePageLayout = () => {
    const [isSmallView, setIsSmallView] = useState(null);

    useEffect(() => {
        const handleResize = () => {
            const showSmallView = window.matchMedia(breakpoints.smMax).matches;

            setIsSmallView(prev => {
                if (!prev && showSmallView) {
                    return true;
                }

                if (prev && !showSmallView) {
                    return false;
                }

                return prev;
            });
        };

        handleResize();
        window.addEventListener(DebouncedResize, handleResize);

        return () => window.removeEventListener(DebouncedResize, handleResize);
    }, []);

    return { isSmallView };
};

export default usePageLayout;
